import styled from '@emotion/styled';
import { Form } from 'antd';
import { Formik, FormikConfig, FormikProps } from 'formik';
import productLine from 'productLine';
import { ReactNode } from 'react';
import AiGroupField from './AiGroupField';
import AutoCloseEnableField from './AutoCloseEnableField';
import OrderAbandonGroupField from './OrderAbandonGroupField';
import ReviewGroupField from './ReviewGroupField';
import { FV } from './share';
import UserTagGroupField from './UserTagGroupField';
import WaitPayTaxesField from './WaitPayTaxesField';

const StyledForm = styled(Form)`
  > * {
    margin-bottom: 16px;
  }
`;

export interface InsiteFormProps extends FormikConfig<FV> {
  children: (form: ReactNode, props: FormikProps<FV>) => ReactNode;
  aiOnly?: boolean;
  applyScope: Remind.ApplyScope;
}

function InsiteForm(props: InsiteFormProps) {
  const { children, aiOnly = false, applyScope, ...otherProps } = props;

  return (
    <Formik enableReinitialize {...otherProps}>
      {(formProps) => {
        const form = aiOnly ? (
          <StyledForm>
            <AiGroupField showNav={false} />
          </StyledForm>
        ) : (
          <StyledForm>
            <AutoCloseEnableField />
            <AiGroupField />
            <UserTagGroupField />
            {productLine !== 'aeplugin' && <OrderAbandonGroupField />}
            {productLine !== 'aeplugin' && <ReviewGroupField />}
            <WaitPayTaxesField applyScope={applyScope} />
          </StyledForm>
        );

        return children(form, formProps);
      }}
    </Formik>
  );
}

export default InsiteForm;
